import { render, staticRenderFns } from "./SelectGoodsCard.vue?vue&type=template&id=7603941c&scoped=true"
import script from "./SelectGoodsCard.vue?vue&type=script&lang=js"
export * from "./SelectGoodsCard.vue?vue&type=script&lang=js"
import style0 from "./SelectGoodsCard.vue?vue&type=style&index=0&id=7603941c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7603941c",
  null
  
)

export default component.exports